/* src/app/account/digital-wallet/dw-rewardship/dw-rewardship.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.banner {
  display: flex;
  width: 100%;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  margin: 0 auto 0 auto;
  border-left: 4px solid rgba(0, 71, 145, 0.73);
  background: var(--ups-brand-colors-ups-blue-avatar, #E3EEF9);
  box-shadow: 0px 4px 12px -3px rgba(0, 0, 0, 0.05), 0px 2px 5px 0px rgba(0, 0, 0, 0.14);
}
.banner .text {
  max-width: 100vw;
  flex-shrink: 0;
  color: var(--ups-brand-colors-ups-black, #121212);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
}
.banner .text-link {
  text-decoration-line: underline;
  color: var(--ups-brand-colors-ups-blue, #0662BB);
  cursor: pointer;
}
.banner button,
.banner .mat-mdc-raised-button {
  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 32px;
  background: var(--ups-brand-colors-ups-gold, #FFC400) !important;
  color: black;
  border: none;
}
.dw-rewardship {
  margin: 0 auto 0 auto;
}
.dw-rewardship .tiles {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 1.5rem;
  padding: 2.5rem 1.5rem 0 1.5rem;
  width: 100%;
  max-width: 100vw;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .tiles {
    gap: 1.5rem;
  }
}
.dw-rewardship .tiles .tile {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  border-radius: 0.25rem;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .tiles .tile {
    max-width: 31%;
  }
  .dw-rewardship .tiles .tile.redeem-card {
    flex: 3.25;
  }
  .dw-rewardship .tiles .tile.auto-redeem-card,
  .dw-rewardship .tiles .tile.point-card {
    flex: 4;
  }
}
.dw-rewardship .tiles .tile.point-card {
  display: none;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .tiles .tile.point-card {
    display: flex;
  }
}
.dw-rewardship .tiles .tile .auto-redeem-action {
  text-align: left;
}
.dw-rewardship .tiles .redeem-card {
  padding: 16px 32px;
  gap: 16px;
}
.dw-rewardship .tiles .redeem-card .inner-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
}
.dw-rewardship .tiles .redeem-card .inner-card .credit-text {
  color: var(--ups-brand-colors-ups-black, #121212);
  font-feature-settings: "clig" off, "liga" off;
  white-space: nowrap;
  font-family: "Roboto Flex", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
}
.dw-rewardship .tiles .redeem-card .inner-card .redeem-points {
  color: var(--ups-brand-colors-ups-black, #121212);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}
.dw-rewardship .tiles .redeem-card .inner-card .action {
  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 32px;
  background: var(--ups-brand-colors-ups-gold, #FFC400);
  font-weight: bold;
}
.dw-rewardship .tiles .redeem-card .inner-card button,
.dw-rewardship .tiles .redeem-card .inner-card .mat-mdc-raised-button {
  margin: 0 0 0.5rem 0;
  padding: 16px 14px 16px 24px;
  background: var(--ups-brand-colors-ups-gold, #FFC400);
  border: none;
  border-radius: 22px;
  color: black;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .tiles .redeem-card .inner-card button,
  .dw-rewardship .tiles .redeem-card .inner-card .mat-mdc-raised-button {
    width: auto;
    margin: 0 0.5rem 0.5rem 0.5rem;
  }
}
.dw-rewardship .tiles .redeem-card .inner-card button .help-container,
.dw-rewardship .tiles .redeem-card .inner-card .mat-mdc-raised-button .help-container {
  position: relative;
}
.dw-rewardship .tiles .redeem-card .inner-card button .help-icon,
.dw-rewardship .tiles .redeem-card .inner-card .mat-mdc-raised-button .help-icon {
  cursor: pointer;
  position: absolute;
  top: -3.5rem;
  right: -1.5rem;
  width: 1em;
  z-index: 9999;
}
.dw-rewardship .tiles .redeem-card .inner-card button .help-popup-message-bubble,
.dw-rewardship .tiles .redeem-card .inner-card .mat-mdc-raised-button .help-popup-message-bubble {
  display: none;
  position: absolute;
  top: -11.8rem;
  left: -2rem;
  background: #F2F1EF;
  width: 270px;
  box-shadow:
    0px 15px 32px -3px rgba(0, 0, 0, 0.08),
    0px 4px 12px -2px rgba(0, 0, 0, 0.08),
    0px 2px 6px 0px rgba(0, 0, 0, 0.06);
  color: #121212;
  border-radius: 4px;
  text-align: center;
  z-index: 9998;
  font-size: 14px;
  white-space: pre-wrap;
}
.dw-rewardship .tiles .redeem-card .inner-card button .help-popup-message-bubble p,
.dw-rewardship .tiles .redeem-card .inner-card .mat-mdc-raised-button .help-popup-message-bubble p {
  padding: 15px;
  margin-bottom: 0;
}
.dw-rewardship .tiles .redeem-card .inner-card button .help-popup-message-bubble .triangleDown,
.dw-rewardship .tiles .redeem-card .inner-card .mat-mdc-raised-button .help-popup-message-bubble .triangleDown {
  width: 0;
  height: 0;
  z-index: 9998;
  border-top: 15px solid #F2F1EF;
  border-right: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid transparent;
  position: absolute;
  top: 7.1rem;
  left: 7.7rem;
}
.dw-rewardship .tiles .redeem-card .inner-card button .help-icon:hover + .help-popup-message-bubble,
.dw-rewardship .tiles .redeem-card .inner-card .mat-mdc-raised-button .help-icon:hover + .help-popup-message-bubble {
  display: block;
}
.dw-rewardship .tiles .redeem-card .inner-card button.mat-mdc-raised-button[disabled] {
  background: var(--ups-bray-lightest, #dfdbd7);
  color: var(--ups-background-color, #cac4bd);
}
.dw-rewardship .tiles .redeem-card-a {
  border-radius: 4px;
  background: var(--ups-brand-colors-ups-grey-5, #F2F1EF);
}
.dw-rewardship .tiles .auto-redeem-card {
  padding: 24px 32px;
  gap: 16px;
  flex-shrink: 0;
  background: var(--ups-brand-colors-ups-grey-5, #F2F1EF);
}
.dw-rewardship .tiles .auto-redeem-card .auto-redeem-headline {
  align-self: stretch;
  color: var(--ups-brand-colors-ups-black, #121212);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
}
.dw-rewardship .tiles .auto-redeem-card .auto-redeem-text {
  align-self: stretch;
  color: var(--ups-brand-colors-ups-black, #121212);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.dw-rewardship .tiles .auto-redeem-card .auto-redeem-action {
  display: flex;
  width: 60px;
  align-items: center;
  gap: 4px;
  border-radius: 32px;
}
.dw-rewardship .tiles .auto-redeem-card ::ng-deep .mat-mdc-slide-toggle {
  --thumb-size: 25px;
}
.dw-rewardship .tiles .auto-redeem-card ::ng-deep .mat-mdc-slide-toggle .mat-slide-toggle-ripple {
  top: calc(50% - var(--thumb-size) + 3px);
  left: calc(50% - var(--thumb-size) + 2px);
  width: calc(var(--thumb-size) * 2);
  height: calc(var(--thumb-size) * 2);
}
.dw-rewardship .tiles .auto-redeem-card ::ng-deep .mat-slide-toggle-bar {
  height: 32px;
  width: 64px;
  border-radius: 25%/50%;
  border: solid 1px #5F5753;
  background-color: white;
}
.dw-rewardship .tiles .auto-redeem-card ::ng-deep .mat-slide-toggle-thumb {
  height: var(--thumb-size);
  width: var(--thumb-size);
  background-color: #5F5753;
}
.dw-rewardship .tiles .auto-redeem-card ::ng-deep .mat-mdc-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar {
  background-color: #0A8080;
}
.dw-rewardship .tiles .auto-redeem-card ::ng-deep .mat-mdc-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb {
  background-color: white;
}
.dw-rewardship .tiles .auto-redeem-card ::ng-deep .mat-mdc-slide-toggle.mat-checked .mat-slide-toggle-thumb-container {
  transform: translate3d(30px, 0, 0) !important;
}
.dw-rewardship .tiles .auto-redeem-card ::ng-deep .mat-slide-toggle-thumb-container {
  margin-top: 5px;
  margin-left: 4px;
}
.dw-rewardship .point-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-items: stretch !important;
  justify-content: center;
  background: #FFF;
  box-shadow: 0px 4px 12px -3px rgba(0, 0, 0, 0.05), 0px 2px 5px 0px rgba(0, 0, 0, 0.14);
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .point-card {
    padding: 20px 24px;
    gap: 20px;
    border-radius: 4px;
  }
}
.dw-rewardship .point-card .points-earned-head-layout {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.dw-rewardship .point-card .points-earned-head-layout .icon {
  width: 2rem;
  height: 2rem;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .point-card .points-earned-head-layout .icon {
    width: 48px;
    height: 48px;
  }
}
.dw-rewardship .point-card .points-earned-head-layout .stats {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: flex-end;
  column-gap: 0.5rem;
  margin-left: auto;
}
.dw-rewardship .point-card .points-earned-head-layout .arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  display: none;
  width: 1.875rem;
  height: 1.875rem;
  padding-top: 3px;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .point-card .points-earned-head-layout .arrow {
    display: flex;
  }
}
.dw-rewardship .point-card .points-earned-head-layout .arrow-response {
  color: var(--ups-brand-colors-ups-grey-2, #8C857E);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  width: 70%;
  text-align: left;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .point-card .points-earned-head-layout .arrow-response {
    width: auto;
  }
}
.dw-rewardship .point-card .earned-points-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .point-card .earned-points-layout {
    row-gap: 1.5rem;
  }
}
.dw-rewardship .point-card .earned-points-layout .earned-points {
  font-size: 2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.5rem;
  align-self: flex-start;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .point-card .earned-points-layout .earned-points {
    align-self: center;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 1.2em;
  }
}
.dw-rewardship .point-card .earned-points-layout .earned-points-text {
  color: var(--ups-brand-colors-ups-black, #121212);
  font-feature-settings: "clig" off, "liga" off;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  align-self: flex-start;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .point-card .earned-points-layout .earned-points-text {
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 1.2em;
    white-space: pre-wrap;
  }
}
.dw-rewardship .attached-tiles-wrapper {
  padding: 1.5rem;
}
.dw-rewardship .attached-tiles-wrapper .attached-tiles {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: space-between;
  box-shadow: 0 4px 12px -3px rgba(0, 0, 0, 0.05), 0 2px 5px 0 rgba(0, 0, 0, 0.14);
  border-radius: 0.25rem;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .attached-tiles-wrapper .attached-tiles {
    display: none;
    box-shadow: none;
  }
}
.dw-rewardship .attached-tiles-wrapper .attached-tiles .point-card {
  box-shadow: none;
}
.dw-rewardship .attached-tiles-wrapper .attached-tiles .point-card:nth-child(odd) {
  position: relative;
  padding: 0.5rem 0.75rem 0.5rem 0.5rem;
}
.dw-rewardship .attached-tiles-wrapper .attached-tiles .point-card:nth-child(odd)::after {
  content: "";
  position: absolute;
  top: 5%;
  right: 0;
  display: block;
  width: 1px;
  height: 90%;
  background-color: #D9D9D9;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .attached-tiles-wrapper .attached-tiles .point-card:nth-child(odd)::after {
    content: unset;
  }
}
.dw-rewardship .attached-tiles-wrapper .attached-tiles .point-card:nth-child(even) {
  padding: 0.5rem 0.5rem 0.5rem 0.75rem;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship .attached-tiles-wrapper .attached-tiles .point-card {
    padding: 1.25rem 1.5rem;
    box-shadow: 0 4px 12px -3px rgba(0, 0, 0, 0.05), 0 2px 5px 0 rgba(0, 0, 0, 0.14);
  }
}
.dw-rewardship .grid {
  display: flex;
  padding: 40px 24px 0px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}
.dw-rewardship .grid .headline {
  display: flex;
  padding-top: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.dw-rewardship .grid .headline .headline-text {
  align-self: stretch;
  color: var(--ups-brand-colors-ups-black, #121212);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}
.dw-rewardship .grid .headline .key-key {
  width: 72px;
  height: 4px;
  background: var(--ups-brand-colors-ups-gold, #FFC400);
}
.dw-rewardship .grid .toolbar {
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid var(--UPSC-Gray-1, #4A4A4C);
  background: var(--ups-brand-colors-ups-grey-5, #F2F1EF);
}
.dw-rewardship .grid .toolbar .box {
  display: flex;
  height: 56px;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
}
.dw-rewardship .grid .toolbar .box .ddl {
  display: flex;
  width: 220px;
  height: 56px;
  padding: 10px 12px;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  border: 1px solid var(--UPSC-Gray-2, #757583);
  background: var(--ups-brand-colors-ups-white, #FFF);
}
.dw-rewardship .grid .toolbar .box .search {
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
}
.dw-rewardship .grid .toolbar .box .search .text {
  display: flex;
  width: 306px;
  height: 56px;
  padding: 10px 12px;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  border: 1px solid var(--UPSC-Gray-2, #757583);
  background: var(--ups-brand-colors-ups-white, #FFF);
}
.dw-rewardship .grid .toolbar .box .search .text .search-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.dw-rewardship .grid .toolbar .box .search .action {
  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background-color: #FFC400;
  border-radius: 32px;
  font-weight: bold;
}
.dw-rewardship .grid .toolbar .box-2 {
  display: flex;
  width: 296px;
  height: 56px;
  justify-content: flex-end;
  align-items: center;
}
.dw-rewardship .grid .toolbar .box-2 .action {
  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background-color: #FFC400;
  border-radius: 32px;
  font-weight: bold;
}
.dw-rewardship .grid .toolbar .box-2 .download {
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
}
.dw-rewardship .grid .toolbar .box-2 .download .icon {
  width: 40px;
  height: 40px;
}
.dw-rewardship .grid .toolbar .box-2 .download .downloadIcon {
  margin-left: 10px;
  width: 27.55px;
  height: 33.16px;
  transform:
    matrix(
      1, 0,
      0, 1,
      0, 0);
}
.dw-rewardship .grid .toolbar .box-2 .download .icon-text {
  color: var(--UPSC-Gray-1, #4A4A4C);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.dw-rewardship-invoice-table {
  font-size: 1rem;
  width: 100%;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.dw-rewardship-invoice-table .table-actions-wrapper {
  padding: 25px;
  padding-bottom: 15px;
}
.dw-rewardship-invoice-table .invoice-table-actions {
  border-radius: 4px;
  border: 1px solid var(--UPSC-Gray-1, #4A4A4C);
  background: var(--ups-brand-colors-ups-grey-5, #F2F1EF);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 15px;
  flex-wrap: wrap;
}
.dw-rewardship-invoice-table .invoice-table-actions .left-action .mat-mdc-form-field {
  background: var(--ups-brand-colors-ups-white, #FFF);
}
.dw-rewardship-invoice-table .invoice-table-actions .right-actions {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: flex-end;
  flex-wrap: wrap;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship-invoice-table .invoice-table-actions .right-actions {
    margin-left: auto;
  }
}
.dw-rewardship-invoice-table .invoice-table-actions .right-action {
  background-color: transparent;
  padding: 0 6px 0 0;
}
.dw-rewardship-invoice-table .invoice-table-actions .right-action.active {
  background-color: #dfdbd7;
}
.dw-rewardship-invoice-table .invoice-table-actions .category-form {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship-invoice-table .invoice-table-actions .category-form {
    max-width: 220px;
  }
}
.dw-rewardship-invoice-table .invoice-table-actions .category-form ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship-invoice-table .invoice-table-actions .category-form ::ng-deep .mat-mdc-form-field {
    width: 90%;
  }
}
.dw-rewardship-invoice-table .invoice-table-actions .search-table-form {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship-invoice-table .invoice-table-actions .search-table-form {
    max-width: 220px;
  }
}
.dw-rewardship-invoice-table .invoice-table-actions .search-table-form .mat-mdc-form-field {
  bottom: 5px;
  width: 100%;
}
.dw-rewardship-invoice-table .invoice-table-actions .search-table-form .mat-mdc-form-field .search-table-form-items {
  display: inline-flex;
}
.dw-rewardship-invoice-table .invoice-table-actions .search-table-form .mat-mdc-form-field .search-table-form-items input {
  margin-left: 5px;
}
.dw-rewardship-invoice-table .invoice-table-actions .date-form {
  height: 55px;
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship-invoice-table .invoice-table-actions .date-form {
    max-width: 220px;
  }
}
.dw-rewardship-invoice-table .invoice-table-actions .date-form .mat-mdc-form-field {
  margin-top: 9px;
  margin-left: 10px;
}
.dw-rewardship-invoice-table .invoice-table-actions .search-button {
  background-color: #FFC400 !important;
  padding: 16px 14px 16px 24px;
  border-radius: 32px;
  border: none;
  color: black;
}
@media screen and (min-width: 48rem) {
  .dw-rewardship-invoice-table .invoice-table-actions .search-button {
    margin-left: 25px;
  }
}
.dw-rewardship-invoice-table .table-filters-wrapper {
  display: none;
}
@media screen and (min-width: 401px) {
  .dw-rewardship-invoice-table .table-filters-wrapper {
    display: block;
    padding: 0 0.5rem;
  }
}
.dw-rewardship-invoice-table .table-filters-wrapper .invoice-table-filters {
  border-radius: 4px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  padding: 15px;
  flex-wrap: wrap;
}
.dw-rewardship-invoice-table .table-filters-wrapper .invoice-table-filters .invoice-table-filter {
  display: inline-flex;
  gap: 5px;
  font-size: 14px;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  background: var(--semantic-colors-ups-warning-yellow-light, #FEF6CC);
}
.dw-rewardship-invoice-table .table-filters-wrapper .invoice-table-filters .invoice-table-filter .close-icon {
  text-decoration: none;
  -webkit-user-select: none;
  user-select: none;
  font-size: 16px;
}
.dw-rewardship-invoice-table .table-filters-wrapper .invoice-table-filters .reset-all-link {
  text-decoration: none;
  margin-left: auto;
  margin-right: 10px;
  color: var(--ups-brand-colors-ups-blue, #0662BB);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 16px;
  font-weight: 700;
}
.dw-rewardship-invoice-table .content-actions input.dw-rewardship-invoice-table-date-range {
  font-size: 0.875em;
}
.dw-rewardship-invoice-table .content-actions .right-actions button.export {
  width: auto;
}
.dw-rewardship-invoice-table .content-actions .right-actions .download {
  cursor: pointer;
}
.dw-rewardship-invoice-table a:hover {
  cursor: pointer;
}
.dw-rewardship-invoice-table a {
  color: black;
}
.dw-rewardship-invoice-table .search-button {
  border-radius: 32px;
  background-color: #FFC400 !important;
  padding: 10px 24px;
  border: none;
  color: black;
}
.dw-rewardship-invoice-table .status .chip {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.125rem;
  text-transform: uppercase;
  border-radius: 0.5rem;
}
.dw-rewardship-invoice-table .status .chip.green-status {
  background-color: #D4EEDD;
  color: #10602C;
}
.dw-rewardship-invoice-table .status .chip.yellow-status {
  background-color: #FEF6CC;
  color: #615100;
}
.dw-rewardship-invoice-table .status .chip.red-status {
  background-color: #FCEAE6;
  color: #991C00;
}
.dw-rewardship-invoice-table .table-container {
  display: none;
}
@media screen and (min-width: 401px) {
  .dw-rewardship-invoice-table .table-container {
    display: block;
    padding: 0 1.5rem;
  }
}
.dw-rewardship-invoice-table .table-container .table-wrapper {
  position: relative;
  width: 100%;
  overflow: auto;
  box-shadow: 0 4px 12px -3px rgba(0, 0, 0, 0.05), 0px 0 5px 0 rgba(0, 0, 0, 0.14);
}
.dw-rewardship-invoice-table .table-container .table-wrapper ::ng-deep .dataTables_wrapper {
  padding: 0;
}
.dw-rewardship-invoice-table .table-container .table-wrapper a:link {
  color: var(--ups-brand-colors-ups-blue, #0662BB);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.dw-rewardship-invoice-table .table-container .table-wrapper .pdf_links a {
  text-decoration: underline;
}
.dw-rewardship-invoice-table .table-container .table-wrapper a:hover {
  color: blue;
}
.dw-rewardship-invoice-table .table-container .table-wrapper a:visited {
  color: blue;
}
.dw-rewardship-invoice-table ::ng-deep .ngx-pagination {
  padding: 0;
}
.dw-rewardship-invoice-table .search {
  cursor: pointer;
}
.white-content-page {
  min-height: 20px !important;
  width: 100%;
  background-color: unset;
}
.white-content-page .content-layout {
  width: 100%;
  height: 100%;
  max-width: 64rem;
  margin: 0 auto;
  background: white;
}
.white-content-page .ups-content-block.content-actions {
  padding: 1.5rem;
}
.white-content-page .ups-content-block.content-actions form .mat-mdc-form-field {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .white-content-page .ups-content-block.content-actions form .mat-mdc-form-field {
    max-width: 15rem;
  }
}
.white-content-page .ups-content-block.content-actions .right-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 1rem;
}
@media screen and (min-width: 48rem) {
  .white-content-page .ups-content-block.content-actions .right-actions {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }
}
.content-disabled {
  position: relative;
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
.content-disabled::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
  filter: brightness(50%);
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
.introduction {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  max-width: 100vw;
  height: auto;
  color: #121212;
  row-gap: 1.5rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
}
@media screen and (min-width: 48rem) {
  .introduction {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 1rem;
  }
}
.introduction .message {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .introduction .message {
    width: 50%;
  }
}
.introduction .message .title {
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 400;
  line-height: 3rem;
  position: relative;
}
.introduction .message .title::before {
  content: "";
  display: block;
  position: absolute;
  bottom: -1rem;
  left: 0;
  width: 4.5rem;
  height: 0.25rem;
  background-color: #ffb500;
}
.introduction .message .description {
  padding: 1rem 0;
  margin: 0;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}
.introduction .message .description:first-of-type {
  margin-top: 1.25rem;
}
.introduction .image {
  display: none;
  width: 100%;
  height: auto;
  max-width: 33.4375rem;
  max-height: 20.75rem;
}
@media screen and (min-width: 48rem) {
  .introduction .image {
    display: block;
    width: 50%;
  }
}
.introduction .image img {
  width: 100%;
  height: auto;
}
ul.features {
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 1.5rem;
  color: #121212;
}
ul.features li.feature {
  width: 100%;
  padding: 0 1rem;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: space-between;
  max-width: 100vw;
}
@media screen and (min-width: 48rem) {
  ul.features li.feature {
    max-width: 50%;
  }
}
@media screen and (min-width: 75rem) {
  ul.features li.feature {
    max-width: 33.3333333333%;
  }
}
ul.features li.feature .feature-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
ul.features li.feature .feature-content .feature-title {
  font-size: 1.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.25rem;
  margin-bottom: 0.75rem;
}
ul.features li.feature .feature-content .feature-description {
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
}
.contact {
  margin-top: 3.75rem;
  padding: 0 23px;
}
@media screen and (min-width: 48rem) {
  .contact {
    padding: 0 32px;
  }
}
.contact .title {
  border-top: solid 2px #d7d7d7;
  color: rgba(36, 36, 36, 0.87);
  font-size: 1.125em;
  font-weight: 600;
  padding: 2.375rem 0 1.75rem;
}
.contact .message {
  font-size: 0.875em;
  line-height: 1.43;
}
.rules {
  font-size: 0.875em;
  padding: 0 23px;
  line-height: 1.57;
  margin: 0.8125rem 0 3.5625rem;
}
@media screen and (min-width: 48rem) {
  .rules {
    padding: 0 32px;
  }
}
@keyframes fadeinmobile {
  from {
    right: -33vw;
  }
  to {
    right: 0px;
  }
}
@keyframes fadein {
  from {
    right: -100vw;
  }
  to {
    right: 0px;
  }
}
.advanced-filter {
  position: relative;
  pointer-events: visible;
}
@media screen and (min-width: 48rem) {
  .advanced-filter {
    margin-left: 10px;
  }
}
.advanced-filter .advanced-filter-panel {
  row-gap: 0.5rem;
  height: 100vh;
  width: 100vw;
  overflow: auto;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  background-color: white;
  border-radius: 4px;
  padding: 1rem 3rem;
  animation: fadein 1s;
}
@media screen and (min-width: 100em) {
  .advanced-filter .advanced-filter-panel {
    width: 33vw;
    animation: fadeinmobile 1s;
    row-gap: 1.2rem;
  }
}
@media screen and (min-width: 65em) and (max-width: 100em) {
  .advanced-filter .advanced-filter-panel {
    width: 40vw;
    animation: fadeinmobile 1s;
    row-gap: 1.2rem;
  }
}
.advanced-filter .advanced-filter-panel .top-actions {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: row-reverse;
  margin-top: 30px;
  margin-right: 15px;
}
.advanced-filter .advanced-filter-panel .top-actions button.close-icon {
  --icon-size: 2.5rem;
  background-color: transparent;
  border: none;
  width: var(--icon-size);
  height: var(--icon-size);
}
.advanced-filter .advanced-filter-panel .top-actions button.close-icon:hover .mat-icon {
  font-weight: 700;
}
.advanced-filter .advanced-filter-panel .top-actions button.close-icon .mat-icon {
  width: var(--icon-size);
  height: var(--icon-size);
  font-size: var(--icon-size);
}
.advanced-filter .advanced-filter-panel .bottom-actions {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: space-around;
  column-gap: 0.75rem;
  padding: 2rem 0 3rem 0;
}
@media screen and (min-width: 48rem) {
  .advanced-filter .advanced-filter-panel .bottom-actions {
    justify-content: flex-start;
    padding: 2rem 0 0 0;
  }
}
.advanced-filter .advanced-filter-panel .date-filter-container {
  margin-top: 15px;
  position: relative;
}
.advanced-filter .advanced-filter-panel .date-filter-container .date-radio-group {
  display: flex;
  flex-direction: column;
}
.advanced-filter .advanced-filter-panel .date-filter-container .date-filter-form-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.advanced-filter .advanced-filter-panel .date-filter-container .date-filter-form-container .date-filter-form {
  height: 55px;
  background: var(--ups-brand-colors-ups-white, #FFF);
  max-width: 210px;
}
.advanced-filter .advanced-filter-panel .date-filter-container .date-filter-form-container .date-filter-form ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  color: var(--UPSC-Gray-2, #757583) !important;
}
.advanced-filter .advanced-filter-panel .date-filter-container .date-filter-form-container .date-filter-form .mat-mdc-form-field {
  max-width: inherit;
}
.advanced-filter .advanced-filter-panel .invoice-filter-container {
  position: relative;
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (min-width: 64rem) {
  .advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container {
    flex-direction: row;
  }
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container .invoice-balance-form {
  height: 3.5rem;
  background: var(--ups-brand-colors-ups-white, #FFF);
  width: 100%;
  margin-bottom: 20px;
}
@media screen and (min-width: 48rem) {
  .advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container .invoice-balance-form {
    margin-bottom: 0px;
  }
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container .invoice-balance-form ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  color: var(--UPSC-Gray-2, #757583) !important;
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container .invoice-balance-form input {
  margin-left: 5px;
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container .invoice-balance-form .mat-mdc-form-field {
  width: inherit;
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container .invoice-balance-form .mat-mdc-form-field .invoice-value-input {
  display: flex;
  flex-direction: row;
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container .invoice-balance-divider {
  display: none;
}
@media screen and (min-width: 48rem) {
  .advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-balance-container .invoice-balance-divider {
    content: "";
    position: relative;
    width: 25px;
    height: 1px;
    margin-top: 35px;
    background-color: #8C857E;
  }
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-error-message {
  margin-top: 15px;
  max-width: 500px;
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-error-message small {
  background-color: var(--ups-error, #c91a13);
  color: white;
  border-radius: 20px;
  padding: 0.75em;
  font-size: 12px;
  font-weight: 700;
}
.advanced-filter .advanced-filter-panel .invoice-filter-container .invoice-slider-container {
  width: 100%;
  margin-top: 20px;
  position: relative;
}
.advanced-filter .advanced-filter-panel .status-filter-container {
  position: relative;
}
.advanced-filter .advanced-filter-panel .status-filter-container .search-status-form {
  max-height: 55px;
  background: var(--ups-brand-colors-ups-white, #FFF);
  width: 100%;
}
.advanced-filter .advanced-filter-panel .status-filter-container .search-status-form ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  color: var(--UPSC-Gray-2, #757583) !important;
}
.advanced-filter .advanced-filter-panel .status-filter-container .search-status-form .mat-mdc-form-field {
  width: inherit;
}
.advanced-filter .advanced-filter-panel .status-filter-container .points-status {
  margin-top: 25px;
}
.advanced-filter .advanced-filter-panel .title {
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 400;
  position: relative;
}
.advanced-filter .advanced-filter-panel .title::before {
  content: "";
  display: block;
  position: absolute;
  bottom: -1.5rem;
  left: 0;
  width: 4.5rem;
  height: 0.25rem;
  background-color: #ffb500;
}
.advanced-filter .advanced-filter-panel .p {
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 3rem;
  position: relative;
}
.advanced-filter .advanced-filter-panel .divider {
  content: "";
  position: relative;
  width: 100%;
  height: 1px;
  background-color: #8C857E;
}
.pagination-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row-reverse;
  padding: 0 1.5rem;
}
@media screen and (min-width: 48rem) {
  .pagination-wrapper {
    padding: 0;
  }
}
.pagination-wrapper ::ng-deep pagination-controls .ngx-pagination {
  justify-content: center;
}
@media screen and (min-width: 48rem) {
  .pagination-wrapper ::ng-deep pagination-controls .ngx-pagination {
    justify-content: flex-end;
  }
}
.select-all-panel-wrapper {
  display: none;
  padding: 0.5rem 1.5rem;
}
@media screen and (max-width: 400px) {
  .select-all-panel-wrapper {
    display: block;
  }
}
.select-all-panel-wrapper .select-all-panel {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.75rem;
  padding: 1rem 0.75rem;
  background-color: #5F5753;
  color: white;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
}
.select-all-panel-wrapper .select-all-panel ::ng-deep .mat-mdc-checkbox {
  margin-right: 0.25rem;
}
.select-all-panel-wrapper .select-all-panel ::ng-deep .mat-mdc-checkbox .mat-checkbox-layout {
  margin: 0;
}
.select-all-panel-wrapper .select-all-panel ::ng-deep .mat-mdc-checkbox .mat-checkbox-layout .mat-checkbox-inner-container {
  margin: 0;
  width: 1.5rem;
  height: 1.5rem;
}
.select-all-panel-wrapper .select-all-panel ::ng-deep .mat-mdc-checkbox .mat-checkbox-layout .mat-checkbox-inner-container .mat-checkbox-frame {
  border-color: #8C857E;
  border-width: 1px;
  border-radius: 0.25rem;
  background-color: white;
}
.invoices {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  display: none;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0 1.5rem;
}
@media screen and (max-width: 400px) {
  .invoices {
    display: flex;
  }
}
::ng-deep .mdc-button .mdc-button__label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
  column-gap: 0;
}
/*# sourceMappingURL=dw-rewardship.component.css.map */
